import { HttpClient } from '../../../api/httpClient' 
import { API_URL } from '../../../api/RestAPI'
import apiHeaders from '../../../api/apiHeaders'

const NOTIFICATION_SETTINGS_API = `${API_URL}/stores`;

const getNotificationSettings = (storeId) => {
  return HttpClient.get(
    `${NOTIFICATION_SETTINGS_API}/${storeId}/notification-settings`,
    apiHeaders()
  );
};

const updateNotificationSettings = (storeId, payload) => {
  return HttpClient.put(
    `${NOTIFICATION_SETTINGS_API}/${storeId}/notification-settings`,
    payload,
    apiHeaders()
  );
};

const NotificationSettingsApi = { getNotificationSettings, updateNotificationSettings };

export { NotificationSettingsApi };